export const TEST_ID = 'tabPanelService';

export const LOG_SERVICE_BUTTON_TEST_ID = 'tabPanelServiceLogButton';
